// トップの「開演」演出（幕・紙吹雪・旗飾り）。home.html.erb は FC の保護対象なので
// script タグを足さず、トップだけが読むこの pack から読み込む。.topPageMain が無いページ（easteregg）では何もしない
import '../../top/stage';

$(function() {
	// トップの本文は custom.scss の .topPageMain { display: none } で隠れていて、
	// 7秒後の fadeIn まで描画されない。LCP が 8秒台、CLS が 0.94 になる原因。
	// home.html.erb 側で style="display: block" を付けて最初から描画し、
	// 不透明な白いオーバーレイ .start を今までどおり 8.5 秒後に消す。
	// 画面に見えるものは変わらない（fadeIn は既に表示中の要素には何もしない）。
	//
	// 本文が描画されるとページの高さが出るので、演出中でもスクロールできてしまう。
	// 演出が明けた時点で画面が下にずれていたら「見た目が変わった」ことになるため、
	// .start を消すまでスクロールを止める。
	// body に直接書かず JS で付けるのは、JS が動かなかったときに
	// スクロールできないページが残らないようにするため。
	$('html, body').css('overflow', 'hidden');
	// Turbolinks は <html> を差し替えないので、演出の途中で別ページへ移ると
	// 止めたスクロールが次のページに残り、オーディションページなどが動かなくなっていた。
	// ページを離れるときと、.start が無くなっていたときは必ず戻す。
	var unlockScroll = function(){ $('html, body').css('overflow', ''); };
	document.addEventListener('turbolinks:before-render', unlockScroll, { once: true });
	setTimeout(function(){
		if (!$('.start').length) { unlockScroll(); return; }
		// stage.js（幕・紙吹雪）への合図。loading を消し始めるのと同時に幕を開ける
		document.dispatchEvent(new Event('circus:curtain'));
		$('.start').fadeOut(800, function(){
			$('html, body').css('overflow', '');
		});
		$('.divFix').fadeOut(1500);
	},8500); //8秒後にロゴ含め真っ白背景をフェードアウト！
  setTimeout(function(){
    $('.topPageMain').fadeIn(1200);
  },7000);//4.6秒後にロmainが表示。
});
